var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"pao",attrs:{"fill-height":""}},[_c('router-view'),_c('dialog-add-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }